import { type LoadingTableColumn } from '../../../../components/Table';

export const PAGE_SIZE = 25;

export const LOADING_TABLE_COLUMNS: LoadingTableColumn[] = [
  { label: 'Supplier', className: 'pl-6' },
  { label: 'Reference ID', className: 'hidden md:table-cell' },
  { label: 'Status', className: 'hidden lg:table-cell' },
  { label: 'Locale', className: 'hidden lg:table-cell' },
];
